import React from "react";
import Rating from "@material-ui/lab/Rating";
import Box from "@material-ui/core/Box";

const divStyle = {
  minWidth: "100%",
  color: "white",
};
const ratingStyle = {
  fontSize: "30px",
};
const submitStyle = {
  backgroundColor: "#C830CC",
  borderRadius: "5px",
  minWidth: "100%",
  height: "60px",
  color: "white",
  left: "5px",
  right: "5px",
};

const emailInputStyle = {
  borderRadius: "5px",
  minWidth: "100%",
  height: "60px",
  color: "black",
  left: "5px",
  right: "5px",
};

const descriptionInputStyle = {
  borderRadius: "5px",
  minWidth: "100%",
  maxWidth: "100%",
  height: "60px",
  color: "black",
  left: "5px",
  right: "5px",
};

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      value: 5,
      description: "",
    };

    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDescriptionChange(event) {
    this.setState({ description: event.target.value });
  }
  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }
  handleValueChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    // mail to
    var mailToLink =
      "mailto:dumitru.radoiu@jacaranda.ro?subject=" +
      "FEEDBACK NOTA:" +
      this.state.value +
      "&body=" +
      encodeURIComponent(this.state.description);
    window.location.href = mailToLink;
  }

  render() {
    return (
      <>
        <div style={divStyle}>
          <form onSubmit={this.handleSubmit}>
            <input
              required
              type="text"
              placeholder="Adresa dvs. de email..."
              value={this.state.email}
              onChange={this.handleEmailChange}
              style={emailInputStyle}
            ></input>
            <textarea
              required
              placeholder="     Asteptam sugestiile dvs. Va multumim!"
              onChange={this.handleDescriptionChange}
              style={descriptionInputStyle}
            />
            <Box component="fieldset" mb={5} borderColor="transparent">
              <Rating
                name="simple-controlled"
                value={this.state.value}
                onChange={this.handleValueChange}
                style={ratingStyle}
              />
            </Box>
            <input type="submit" value="Submit" style={submitStyle} />
          </form>
        </div>
      </>
    );
  }
}
export default Feedback;
